export default __webpack_public_path__ + "static/media/collapse-nav.69c7de00.svg";